import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  PWA_LOCATIONS_FEATURE_KEY,
  LocationsState,
  locationsAdapter
} from './pwa-locations.reducer';

// Lookup the 'Location' feature state managed by NgRx
export const getLocationState = createFeatureSelector<LocationsState>(PWA_LOCATIONS_FEATURE_KEY);

const { selectAll, selectEntities, selectIds, selectTotal } = locationsAdapter.getSelectors();

export const getLocationsLoaded = createSelector(
  getLocationState,
  (state: LocationsState) => state.locationLoaded
);

export const getLocationsLoadError = createSelector(
  getLocationState,
  (state: LocationsState) => state.locationLoadError
);

export const getAddLocationSuccess = createSelector(
  getLocationState,
  (state: LocationsState) => state.addLocationSuccess
);


export const getAddLocationError = createSelector(
  getLocationState,
  (state: LocationsState) => state.addLocationError
);


export const getUpdateLocationSuccess = createSelector(
  getLocationState,
  (state: LocationsState) => state.updateLocationSuccess
);


export const getUpdateLocationError = createSelector(
  getLocationState,
  (state: LocationsState) => state.updateLocationError
);


export const getDeleteLocationSuccess = createSelector(
  getLocationState,
  (state: LocationsState) => state.deleteLocationSuccess
);


export const getDeleteLocationError = createSelector(
  getLocationState,
  (state: LocationsState) => state.deleteLocationError
);


export const getQueryLocationError = createSelector(
  getLocationState,
  (state: LocationsState) => state.queryLocationLoadError
);

export const getLocations = createSelector(getLocationState, (state: LocationsState) => selectAll(state));

export const getLocationsDictionary = createSelector(getLocationState, (state: LocationsState) => state.entities);


export const getActiveLocations = createSelector(getLocations,
  (locations) =>
    locations.filter(item => item.active)
);


export const getLocationById = createSelector(getLocations,
  (locations, props) =>
    locations.find(item => item.id === props.id)
);







